import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class LocalCustomValidators {
  static orderValidator(orderNumbersArray, boolean, number): ValidatorFn {
    return orderValidator(orderNumbersArray, boolean, number);
  }

  static dateRangeValidator(min: Date, max: Date, checkTime: boolean = false): ValidatorFn {
    return dateRangeValidator(min, max, checkTime);
  }
}

function isEmptyInputValue(value: any): boolean {
  return (
    value == null || ((typeof value === 'string' || Array.isArray(value)) && value.length === 0)
  );
}

export function orderValidator(
  orderNumbersArray: number[],
  editMode: boolean,
  currentOrder: number,
): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    let errorBool = false;
    if (isEmptyInputValue(c.value)) {
      return null;
    }

    if (editMode) {
      if (Number(currentOrder) !== Number(c.value) && orderNumbersArray.includes(Number(c.value))) {
        errorBool = true;
      }
    } else {
      if (orderNumbersArray.includes(Number(c.value))) {
        errorBool = true;
      }
    }

    return !errorBool
      ? null
      : {
          orderValidator: true,
        };
  };
}

export function dateRangeValidator(min: Date, max: Date, checkTime: boolean = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    const value = new Date(control.value);
    if (isNaN(value.getTime())) {
      return { invalidDate: true };
    }

    const getDateOnly = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    let valueToCheck: Date = getDateOnly(value);
    let minToCheck: Date = getDateOnly(min);
    let maxToCheck: Date = getDateOnly(max);

    if (checkTime) {
      valueToCheck = value;
      minToCheck = min;
      maxToCheck = max;
    }

    if (valueToCheck > maxToCheck) {
      return { dateRangeMax: true };
    }

    if (valueToCheck < minToCheck) {
      return { dateRangeMin: true };
    }

    return null;
  };
}
